export const getUrlHostname = (url: string): string => {
  try {
    const structuredUrl = new URL(url);
    return structuredUrl.hostname;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return '';
  }
};
